import { COLORS } from "./../../Features/UI/helpers/index.helper";

export const getCellColor = (truckName: string, trackerName: string, date: string, selectedMonth: Date) => {
  if (new Date(date).getMonth() !== selectedMonth.getMonth()) return COLORS.darkGrey;
  if (truckName.includes("Hold") && trackerName !== "") return COLORS.yellow;
  if (!truckName.includes("Hold") && trackerName !== "") return COLORS.green;

  return COLORS.white;
};
